import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { useParams, Link } from "react-router-dom";
import StoreData from "../../../Data/StoreData";
import ProductDetail from "../../../Data/productdetail";

import product1 from "../../../Assets/ProductDetail/productdetail-1.jpg";
import product2 from "../../../Assets/ProductDetail/productdetail-2.jpg";
import product3 from "../../../Assets/ProductDetail/productdetail-3.jpg";
import product4 from "../../../Assets/ProductDetail/productdetail-4.jpg";

import { GoChevronLeft } from "react-icons/go";
import { GoChevronRight } from "react-icons/go";
import { FaStar } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { PiShareNetworkLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";

import "./Product.css";

const Product = () => {
  const { productId } = useParams();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.items);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();

  // Product Data State
  const [productData, setProductData] = useState(null);

  // Product images Gallery
  const [productImg, setProductImg] = useState([product1, product2, product3, product4]);
  const [currentImg, setCurrentImg] = useState(0);

  // Product Quantity
  const [quantity, setQuantity] = useState(1);

  // Product WishList
  const [clicked, setClicked] = useState(false);

  // Product Sizes
  const sizes = ["XS", "S", "M", "L", "XL"];
  const sizesFullName = ["Extra Small", "Small", "Medium", "Large", "Extra Large"];
  const [selectSize, setSelectSize] = useState("S");

  // Product Colors
  const [highlightedColor, setHighlightedColor] = useState("#C8393D");
  const colors = ["#222222", "#C8393D", "#E4E4E4"];
  const colorsName = ["Black", "Red", "Grey"];

    // Find the current product based on URL parameter
    const currentProduct = ProductDetail.find(
      (product) => product.productID === parseInt(productId)
    ) || ProductDetail[0]; // Fallback to first product if not found

  useEffect(() => {
    if (productId) {
      const foundProduct = StoreData.find(p => p.productID === parseInt(productId));
      if (foundProduct) {
        setProductData(foundProduct);
        // If the product has its own images, update them
        if (foundProduct.images) {
          setProductImg(foundProduct.images);
        }
      }
    }
  }, [productId]);

  const handleDirectOrder = () => {
    setShowConfirmation(true);
  };

  const confirmAndProceedToCheckout = () => {
    // Use navigate instead of window.location.href
    navigate(`/cart?directOrder=${productData.productID}`);
    setShowConfirmation(false);
  };

  const prevImg = () => {
    setCurrentImg(currentImg === 0 ? productImg.length - 1 : currentImg - 1);
  };

  const nextImg = () => {
    setCurrentImg(currentImg === productImg.length - 1 ? 0 : currentImg + 1);
  };

  const increment = () => {
    setQuantity(quantity + 1);
  };

  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleInputChange = (event) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value) && value > 0) {
      setQuantity(value);
    }
  };

  const handleWishClick = () => {
    setClicked(!clicked);
  };

  const handleAddToCart = () => {
    if (!productData) return;

    const productDetails = {
      productID: productData.productID,
      productName: productData.productName,
      productPrice: productData.productPrice,
      frontImg: productData.frontImg || productImg[0],
      productReviews: productData.productReviews,
      quantity: quantity
    };

    const productInCart = cartItems.find(
      (item) => item.productID === productDetails.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(productDetails));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const shareContent = () => {
    const productName = "Your Product Name"; // Replace with your actual product name variable
    const shareUrl = window.location.href;
    
    if (navigator.share) {
      // For Web Share API (mobile devices primarily)
      navigator.share({
        title: productName,
        text: `Check out ${productName}`,
        url: shareUrl
      })
      .catch(error => console.log('Error sharing:', error));
    } else {
      // For clipboard copy (desktop primarily)
      // Format: Product Name: URL
      const textToCopy = `${productName}: ${shareUrl}`;
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          const notification = document.createElement('div');
          notification.className = 'copy-notification';
          notification.textContent = 'Link copied to clipboard with product name!';
          notification.style.cssText = `
            position: fixed;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #333;
            color: white;
            padding: 10px 20px;
            border-radius: 4px;
            z-index: 1000;
          `;
          document.body.appendChild(notification);
          
          setTimeout(() => {
            document.body.removeChild(notification);
          }, 2000);
        })
        .catch(err => console.error('Failed to copy: ', err));
    }
  };

  if (!productData) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="productSection">
        <div className="productShowCase">
          <div className="productGallery">
            <div className="productThumb">
              {productImg.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  onClick={() => setCurrentImg(index)}
                  alt=""
                />
              ))}
            </div>
            <div className="productFullImg">
              <img src={productImg[currentImg]} alt="" />
              <div className="buttonsGroup">
                <button onClick={prevImg} className="directionBtn">
                  <GoChevronLeft size={18} />
                </button>
                <button onClick={nextImg} className="directionBtn">
                  <GoChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
          <div className="productDetails">
            <div className="productBreadcrumb">
              <div className="breadcrumbLink">
                <Link to="/">Home</Link>&nbsp;/&nbsp;
                <Link to="/shop">The Shop</Link>
              </div>
              <div className="prevNextLink">
                <Link to="/product">
                  <GoChevronLeft />
                  <p>Prev</p>
                </Link>
                <Link to="/product">
                  <p>Next</p>
                  <GoChevronRight />
                </Link>
              </div>
            </div>
            <div className="productName">
              <h1>{productData.productName}</h1>
            </div>
            <div className="productRating">
                  {[...Array(5)].map((_, index) => (
                                <FaStar
                                  key={index}
                                  color={index < productData.stars ? "#FEC78A" : "#C4C4C4"}
                                  size={10}
                                />
                  ))}
              <p>{productData.productReviews}</p>
            </div>
            <div className="productPrice">
              {productData?.metalType?.toLowerCase() === 'gold' ? (
                <>
                  <h3>Price Upon Request</h3>
                  <p style={{ 
                    color: '#FF0000', 
                    fontSize: '12px', 
                    marginTop: '5px' 
                  }}>
                    * Prices are not available online due to varying gold prices. Please visit Hussain Sons Jewelers for pricing and further consultation.
                  </p>
                </>
              ) : (
                <h3>${productData?.productPrice}</h3>
              )}
            </div>
            <div className="productDescription">
              <p>
                {currentProduct.description || 
                  "Phasellus sed volutpat orci. Fusce eget lore mauris vehicula elementum gravida nec dui. Aenean aliquam varius ipsum, non ultricies tellus sodales eu. Donec dignissim viverra nunc, ut aliquet magna posuere eget."}
              </p>
            </div>
            <div className="productSizeColor">
              <div className="productSize">
                <p>Sizes</p>
                <div className="sizeBtn">
                  {sizes.map((size, index) => (
                    <Tooltip
                      key={size}
                      title={sizesFullName[index]}
                      placement="top"
                      TransitionComponent={Zoom}
                      enterTouchDelay={0}
                      arrow
                    >
                      <button
                        style={{
                          borderColor: selectSize === size ? "#000" : "#e0e0e0",
                        }}
                        onClick={() => setSelectSize(size)}
                      >
                        {size}
                      </button>
                    </Tooltip>
                  ))}
                </div>
              </div>
              <div className="productColor">
                <p>Color</p>
                <div className="colorBtn">
                  {colors.map((color, index) => (
                    <Tooltip
                      key={color}
                      title={colorsName[index]}
                      placement="top"
                      enterTouchDelay={0}
                      TransitionComponent={Zoom}
                      arrow
                    >
                      <button
                        className={
                          highlightedColor === color ? "highlighted" : ""
                        }
                        style={{
                          backgroundColor: color.toLowerCase(),
                          border:
                            highlightedColor === color
                              ? "0px solid #000"
                              : "0px solid white",
                          padding: "8px",
                          margin: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => setHighlightedColor(color)}
                      />
                    </Tooltip>
                  ))}
                </div>
              </div>
            </div>
            {productData?.metalType?.toLowerCase() === 'gold' ? (
              <div className="productCartQuantity">
                <div className="productCartButtons">
                  <Link to="/contact" className="contact-price-btn">
                    Contact for Price
                  </Link>
                  <button onClick={handleDirectOrder} className="place-order-btn">
                    Place Order Now
                  </button>
                </div>
                
                {/* Confirmation Dialog */}
                {showConfirmation && (
                  <div className="confirmation-overlay" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                  }}>
                    <div className="confirmation-dialog" style={{
                      backgroundColor: 'white',
                      padding: '30px',
                      borderRadius: '8px',
                      maxWidth: '500px',
                      textAlign: 'center'
                    }}>
                      <h3 style={{ marginBottom: '20px' }}>Order Confirmation</h3>
                      <p style={{ marginBottom: '25px', lineHeight: '1.6' }}>
                        I confirm that I have contacted Hussain Sons Jewelers and have agreed to pay the corresponding price for {productData.productName}.
                      </p>
                      <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                        <button 
                          onClick={() => setShowConfirmation(false)}
                          style={{
                            padding: '10px 20px',
                            backgroundColor: '#e0e0e0',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          Cancel
                        </button>
                        <button 
                          onClick={confirmAndProceedToCheckout}
                          style={{
                            padding: '10px 20px',
                            backgroundColor: '#C8393D',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          Confirm & Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="productCartQuantity non-precious">
              <div className="productQuantity">
                <button onClick={decrement}>-</button>
                <input
                  type="text"
                  value={quantity}
                  onChange={handleInputChange}
                />
                <button onClick={increment}>+</button>
              </div>
              <div className="productCartBtn">
                <button onClick={handleAddToCart}>Add to Cart</button>
              </div>
            </div>
            )}
            <div className="productWishShare">
              <div className="productWishList">
                <button onClick={handleWishClick}>
                  <FiHeart color={clicked ? "red" : ""} size={17} />
                  <p>Add to Wishlist</p>
                </button>
              </div>
              <div 
                className="productShare" 
                onClick={shareContent}
                role="button"
                tabIndex={0}
              >
                <PiShareNetworkLight size={22} />
                <p>Share</p>
              </div>
            </div>
            <div className="productTags">
              <p>
                <span>SKU: </span>{productData.sku || "N/A"}
              </p>
              <p>
                <span>CATEGORY: </span>{productData.category || "N/A" }
              </p>
              <p>
                <span>TAGS: </span>{productData.tags ? productData.tags.join(", ") : "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;